import { render, staticRenderFns } from "./_VpcWatcher.vue?vue&type=template&id=70739ba1"
import script from "./_VpcWatcher.vue?vue&type=script&lang=ts"
export * from "./_VpcWatcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports